"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureStatusEnum = void 0;
/**
 * Статус фичи
 *
 * @see FeatureEnum
 */
var FeatureStatusEnum;
(function (FeatureStatusEnum) {
  /** включена для всех */
  FeatureStatusEnum[FeatureStatusEnum["enabled"] = 1] = "enabled";
  /** выключена для всех */
  FeatureStatusEnum[FeatureStatusEnum["disabled"] = 2] = "disabled";
  /** не используется, устарело */
  FeatureStatusEnum[FeatureStatusEnum["not_used_deprecated"] = 3] = "not_used_deprecated";
  /**
   * включена в режиме "промо"
   *
   * в режиме промо часть функций видна только как рекламные заглушки с целью снять пользовательские метрики
   */
  FeatureStatusEnum[FeatureStatusEnum["enabled_as_promo"] = 4] = "enabled_as_promo";
})(FeatureStatusEnum = exports.FeatureStatusEnum || (exports.FeatureStatusEnum = {}));
